import React from "react";
import { Affix, Row, Col, Icon, Dropdown, Button, Menu } from "antd";

export const HeaderComponent = props => {
  const {
    languages,
    currentLang,
    currentTab,
    configuration,
    handleButtonClick,
    handleMenuClick,
    previousTab,
    visible,
    language,
    logoClicked,
    helpClicked
  } = props;
  const menu = (
    <Menu onClick={handleMenuClick}>
      {languages.map(item => (
        <Menu.Item key={item}>{item}</Menu.Item>
      ))}
    </Menu>
  );
  const hasLogo =
    configuration.mobileLogo !== "#" && configuration.mobileLogo !== "";
  return (
    <Affix>
      <div className="mobile--header">
        <Row>
          <Col span={8}>
            {currentTab === "1" || currentTab === "2" ? (
              !hasLogo ? (
                <span className="header-title-logo">
                  {configuration.mobileTitle}
                </span>
              ) : (
                <div
                  onClick={logoClicked}
                  id="headerLogo"
                  style={{
                    backgroundImage: "url(" + configuration.mobileLogo + ")"
                  }}
                />
              )
            ) : (
              <Button
                id="backButton"
                onClick={props.goBack}
                size="small"
                type="primary"
              >
                <Icon type="caret-left" />
                {language.data.back}
              </Button>
            )}
          </Col>
          <Col className="text-center" span={8}>
            <div style={{ paddingTop: "3px" }}>
              {language.data.order} {props.orderNumber}
            </div>
          </Col>
          <Col className="text-right" span={8}>
            <Dropdown overlay={menu} visible={visible}>
              <Button
                style={{ background: "none", border: "none" }}
                size="small"
                type="primary"
                onClick={handleButtonClick}
              >
                {currentLang}
              </Button>
            </Dropdown>
            <Button
              style={{ background: "none", border: "none" }}
              size="small"
              type="primary"
              onClick={helpClicked}
            >
              <Icon type="question-circle" />
            </Button>
          </Col>
        </Row>
      </div>
    </Affix>
  );
};



// WEBPACK FOOTER //
// ./src/components/Mobile/Header/HeaderComponent.js